import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "mobile-patrols-sydney";
const serviceId = 2;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Mobile Patrols Sydney | Ozy Wide Group",
    description:
      "Scheduled and responsive patrol support to deter unwanted activity and check Sydney properties after hours.",
    keywords:
      "mobile patrols Sydney, security patrols, alarm response, lockup service, unlock service, after hours security",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Mobile Patrols",
    description:
      "Scheduled and responsive patrol support to deter unwanted activity and check Sydney properties after hours.",
    points: createServicePoints(
      "Patrol frequency and checkpoints agreed",
      "Visible deterrence and site checks provided",
      "Incidents escalated through clear contacts",
    ),
    images: createImageItems(images, "Mobile Patrols Sydney"),
    content,
  };
